<div class="max-w-[443px]">
    <h1 mat-dialog-title class="font-medium text-[22px] text-neutral-800" #titleDialog>{{ title }}</h1>
    <mat-divider></mat-divider>

    <mat-dialog-content class="flex flex-col gap-4 m-0 p-4 text-neutral-800">
        <span *ngIf="content" class="text-lg break-words" [innerHTML]="content"></span>
        <form *ngIf="inputs" class="flex flex-col gap-4" [formGroup]="form">
            <div *ngFor="let input of inputs">
                <ng-container *ngIf="input.selectInput === 'textarea'">
                    <mat-form-field class="min-w-96">
                        <mat-label>{{ input.label }}</mat-label>
                        <textarea [id]="input.id" matInput cdkTextareaAutosize #textarea #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5" maxlength="250"
                            [formControlName]="input.id"></textarea>
                    </mat-form-field>

                    <div *ngIf="input.showCharacters" class="pt-1 px-4 text-end">
                        <span class="text-neutral-600">{{ form.get(input.id).value.length || 0 }}/250</span>
                    </div>
                </ng-container>

                <ng-container *ngIf="input.selectInput === 'input'">
                    <mat-form-field appearance="outline" class="min-w-96">
                        <mat-label>{{ input.label }}</mat-label>
                        <input matInput [id]="input.id" [type]="input.type || 'text'" [placeholder]="input.placeholder"
                            [formControlName]="input.id" />
                    </mat-form-field>
                    <mat-error *ngIf="input?.patternErrorText && form.get(input.id).hasError('pattern')"
                        class="text-12px"
                    >
                        {{ input.patternErrorText }}
                    </mat-error>
                    <mat-error *ngIf="input?.checkPassword && form.get(input.id).hasError('notMatch') && !form.get(input.id).hasError('pattern')"
                        class="text-12px"
                    >
                        {{ input.matchErrorText }}
                    </mat-error>
                </ng-container>

                <ng-container *ngIf="input.selectInput === 'document'">
                    <mat-form-field class="min-w-96">
                        <mat-label>{{ input.label }}</mat-label>
                        <input type="file" matInput (change)="onFileSelected($event, input)" [accept]="input.accept">
                        <mat-icon matSuffix>attach_file</mat-icon>
                    </mat-form-field>

                    <mat-error
                        *ngIf="input.showError && !selectedFile && form.get(input.id).hasError('required') && form.get(input.id).touched">
                        Select a file to continue.
                    </mat-error>
                </ng-container>

                <ng-container *ngIf="input.selectInput === 'select'">
                    <mat-form-field class="min-w-96">
                        <mat-label>{{ input.label }}</mat-label>
                        <mat-select [placeholder]="input.placeholder" [formControlName]="input.id" #select>
                            <mat-option *ngFor="let value of input.values" [id]="value.code" [value]="value.code">
                                {{ value.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-error
                        *ngIf="input.showError && form.get(input.id).hasError('required') && form.get(input.id).touched">
                        {{ input.errorText }}
                    </mat-error>
                </ng-container>

            </div>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions class="flex flex-row gap-3 justify-end m-0 pt-3 p-4">
        <button *ngFor="let button of buttons" mat-stroked-button class="m-0 dialog-action-button" [ngClass]="button.class"
            [ngStyle]="button.style" (click)="button.action()">
            {{ button.label }}
        </button>
    </mat-dialog-actions>

</div>
